/** Launcher shell bridge (platform spec §5). Works without Tauri; buttons no-op in a browser. */
declare global {
  interface Window { __TAURI__?: { window?: { getCurrentWindow(): { minimize(): Promise<void>; close(): Promise<void> } } } }
}
const params = new URLSearchParams(location.search);
export const shell = {
  isLauncher: params.get("shell") === "launcher" || !!window.__TAURI__,
  minimize: () => void window.__TAURI__?.window?.getCurrentWindow().minimize(),
  close: () => void window.__TAURI__?.window?.getCurrentWindow().close(),
  /** Open the game: full window in the browser; in the launcher a new, large window. */
  play(build: string): void {
    const url = `/game/?v=${encodeURIComponent(build)}`;
    if (window.__TAURI__) window.open(url, "bitdepth-game");
    else location.href = url;
  },
};
export {};
